import React from 'react';

import './CardSimulaciones.css';
       
import imgEnfermeria from "../../../assets/img/imagenes-espacios/enfermeria.jpg"
import imgEnfermeria2 from "../../../assets/img/imagenes-espacios/enfermeria11.jpg"


const CardSimulaciones = () => {
  return (
    <div className="galeria-page">

      {/* Card Centro de Simulación */}
      <article className="card-simulacion">
        <div className="card-simulacion__bar" />
        
        <div className="card-simulacion__body">
          <h2 className="card-simulacion__title">Centro de simulación</h2>
          
          <p className="card-simulacion__description">
          El Aula de Laboratorio del Instituto de Educación de la Cruz Roja Seccional Sucre está equipada para 
          prácticas científicas y biomédicas. Los estudiantes pueden realizar análisis, pruebas y simulaciones 
          que fortalecen su formación técnica en áreas como microbiología, química y bioseguridad. Este espacio 
          fomenta el pensamiento crítico, el trabajo colaborativo y el respeto por los protocolos de seguridad, 
          esenciales en el entorno sanitario.
          </p>

          <div className="card-simulacion__gallery">
            <div className="card-simulacion__img-container">
              <img 
                src={imgEnfermeria}
                alt="Aula de laboratorio con esqueleto y equipos" 
                className="card-simulacion__img"
              />
            </div>

            <div className="card-simulacion__img-container">
              <img 
                src={imgEnfermeria2}
                alt="Espacio de práctica y simulación médica" 
                className="card-simulacion__img"
              />
            </div>
          </div>
        </div>
      </article>
    </div>
  );
};

export default CardSimulaciones;